import React from 'react';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const GalleryContent = () => {

  return (
    <section className="portfolio-page-section p_relative">
            <div className="outer-container">
                <div className="sortable-masonry">
                    <div className="filters mb_50">
                        <ul className="filter-tabs filter-btns clearfix centred">
                            <li className="active filter" data-role="button" data-filter=".all">All</li>
                            <li className="filter" data-role="button" data-filter=".surgical">Surgical</li>
                            <li className="filter" data-role="button" data-filter=".paeditaric">Paeditaric</li>
                            <li className="filter" data-role="button" data-filter=".lenses" style={{display: 'none'}}>Lenses</li>
                            <li className="filter" data-role="button" data-filter=".equipment">Equipment</li>
                        </ul>
                    </div>
                    <div className="items-container clearfix">
                        {/* Pediatric Care */}
                        <div className="masonry-item small-column all paeditaric">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_23_pediatric.jpeg" alt="Pediatric Eye Care" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_23_pediatric.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Pediatric Care</a></h3>
                                        <span>Pediatrics</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Eye Camp */}
                        <div className="masonry-item small-column all paeditaric">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_21_eye_camp.jpeg" alt="Eye Camp" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_21_eye_camp.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Eye Camp</a></h3>
                                        <span>Community Service</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Surgery */}
                        <div className="masonry-item small-column all surgical">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_14_at_surgery.jpeg" alt="Surgery" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_14_at_surgery.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Surgery</a></h3>
                                        <span>Surgical Procedure</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Post-Op 1 */}
                        <div className="masonry-item small-column all surgical">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_11_post_op.jpeg" alt="Post-Operative Care" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_11_post_op.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Post-Operative Care</a></h3>
                                        <span>Surgical</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Post-Op 2 */}
                        <div className="masonry-item small-column all surgical">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_18_post_op.jpeg" alt="Post-Operative Care" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_18_post_op.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Post-Operative Care</a></h3>
                                        <span>Surgical</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Solo Scrubs */}
                        <div className="masonry-item small-column all surgical">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_16_solo_scrubs.jpeg" alt="Surgical Team" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_16_solo_scrubs.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Surgical Team</a></h3>
                                        <span>Surgical</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Examination 1 */}
                        <div className="masonry-item small-column all equipment">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_3_examination.jpeg" alt="Eye Examination" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_3_examination.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Eye Examination</a></h3>
                                        <span>Diagnostic</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Examination 2 */}
                        <div className="masonry-item small-column all equipment">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_6_examination_5.jpeg" alt="Eye Examination" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_6_examination_5.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Eye Examination</a></h3>
                                        <span>Diagnostic</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Examination 3 */}
                        <div className="masonry-item small-column all equipment">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_7_examination_4.jpeg" alt="Eye Examination" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_7_examination_4.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Eye Examination</a></h3>
                                        <span>Diagnostic</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Examination 4 */}
                        <div className="masonry-item small-column all equipment">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_12_examination_3.jpeg" alt="Eye Examination" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_12_examination_3.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Eye Examination</a></h3>
                                        <span>Diagnostic</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Examination 5 */}
                        <div className="masonry-item small-column all equipment">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_20_examination_2.jpeg" alt="Eye Examination" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_20_examination_2.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Eye Examination</a></h3>
                                        <span>Diagnostic</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Examination 6 */}
                        <div className="masonry-item small-column all surgical">
                            <div className="project-block-one">
                                <div className="inner-box">
                                    <figure className="image-box"><img src="assets/images/team/Sunshine_eye_care_22_examination.jpeg" alt="Eye Examination" /></figure>
                                    <div className="view-btn"><a href="assets/images/team/Sunshine_eye_care_22_examination.jpeg" className="lightbox-image" data-fancybox="gallery"><i className="icon-33"></i></a></div>
                                    <div className="text">
                                        <h3><a href="#">Eye Examination</a></h3>
                                        <span>Diagnostic</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
    );
  }
  
  export default GalleryContent;